var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-event rounded",class:_vm.event.color || 'primary'},[_c('div',{staticClass:"event-title"},[_vm._v(_vm._s(_vm.event.title))]),(_vm.event.subtitle)?_c('div',{staticClass:"event-subtitle"},[_vm._v(" "+_vm._s(_vm.event.subtitle)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }